"use client"

import { useState, useEffect } from "react"

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false)

  // Helper function to safely interact with localStorage
  const safeStorage = {
    getItem: (key) => {
      try {
        return typeof window !== 'undefined' ? localStorage.getItem(key) : null
      } catch (e) {
        console.error('Error accessing localStorage:', e)
        return null
      }
    },
    setItem: (key, value) => {
      try {
        if (typeof window !== 'undefined') {
          localStorage.setItem(key, value)
        }
      } catch (e) {
        console.error('Error writing to localStorage:', e)
      }
    }
  }

  useEffect(() => {
    // Wait for document to be fully loaded to avoid hydration mismatch
    const timer = setTimeout(() => {
      // Check if user has already given consent
      const consent = safeStorage.getItem("cookie-consent")
      if (!consent) {
        setIsVisible(true)
      }
    }, 500)
    
    return () => clearTimeout(timer)
  }, [])

  const acceptCookies = () => {
    safeStorage.setItem("cookie-consent", "accepted")
    setIsVisible(false)
    
    // Reload page to apply consent (cleaner than dynamically loading scripts)
    window.location.reload()
  }

  const declineCookies = () => {
    safeStorage.setItem("cookie-consent", "declined")
    setIsVisible(false)
    
    // Attempt to disable Google cookies
    const disableGoogleCookies = () => {
      // Try to set cookie preferences to minimal
      try {
        // Create special cookie to opt out of Google Analytics
        const expires = new Date()
        expires.setFullYear(expires.getFullYear() + 2)
        
        // Set various opt-out cookies
        document.cookie = `ga-disable=true; expires=${expires.toUTCString()}; path=/; Secure; SameSite=Strict`
        document.cookie = `__gaOptOut=true; expires=${expires.toUTCString()}; path=/; Secure; SameSite=Strict`
      } catch (error) {
        // Silently fail to avoid console errors
      }
    }
    
    try {
      disableGoogleCookies()
    } catch (error) {
      // Silently fail to avoid console errors
    }
    
    // Reload page to apply consent (cleaner than dynamically removing scripts)
    window.location.reload()
  }

  if (!isVisible) return null

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-gray-800 text-white py-4 px-6 z-50">
      <div className="container mx-auto flex flex-col md:flex-row items-center justify-between">
        <div className="mb-4 md:mb-0 md:mr-4">
          <p className="mb-1">
            Ce site utilise des cookies pour améliorer votre expérience et pour le fonctionnement du formulaire de contact. 
          </p>
          <p className="text-sm">
            En acceptant, vous consentez à l'utilisation des cookies essentiels pour le fonctionnement du site.
            <a href="/mentions-legales" className="text-green-400 hover:text-green-300 ml-1 underline">En savoir plus</a>
          </p>
        </div>
        <div className="flex space-x-4">
          <button
            onClick={acceptCookies}
            className="bg-green-600 hover:bg-green-700 text-white font-medium py-2 px-4 rounded transition-colors"
            aria-label="Accepter les cookies"
          >
            Accepter
          </button>
          <button
            onClick={declineCookies}
            className="bg-transparent hover:bg-gray-700 text-white font-medium py-2 px-4 rounded border border-white transition-colors"
            aria-label="Refuser les cookies"
          >
            Refuser
          </button>
        </div>
      </div>
    </div>
  )
}

export default CookieConsent 